var map = {
	"./directives/templates/addFriends.html": 3108,
	"./directives/templates/chatAbuseReport.html": 9080,
	"./directives/templates/chatAvatarHeadshot.html": 3905,
	"./directives/templates/chatBar.html": 7193,
	"./directives/templates/chatBase.html": 6823,
	"./directives/templates/chatDialog.html": 4466,
	"./directives/templates/chatGameIcon.html": 7993,
	"./directives/templates/chatGroupDialog.html": 9651,
	"./directives/templates/chatPlaceholder.html": 7197,
	"./directives/templates/confirmNegativeAction.html": 115,
	"./directives/templates/conversationTitle.html": 4389,
	"./directives/templates/conversationTitleEditor.html": 3040,
	"./directives/templates/createChatGroup.html": 155,
	"./directives/templates/details.html": 8636,
	"./directives/templates/dialogHeader.html": 9009,
	"./directives/templates/dialogMinimize.html": 5992,
	"./directives/templates/displayMessage.html": 8089,
	"./directives/templates/gamesList.html": 8249,
	"./directives/templates/linkCard.html": 5558,
	"./directives/templates/pendingState.html": 856,
	"./directives/templates/selectFriends.html": 2755,
	"./directives/templates/systemMessage.html": 2038,
	"./directives/templates/userConversationInfo.html": 9392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5251;